import styled from 'styled-components';

export const PostContainer = styled.div`
    flex: 2;
    display: flex;   
    align-items: center;
    justify-content: center; 
    flex-wrap: wrap;
    margin-bottom: 30px;
    width: 100%;
`;
